'use client';

import { type ICollectionPipelineStatusV3, mineGrammarCollectionV1Api } from '@repo/sdk';
import type { JSX } from 'react';
import { useCallback } from 'react';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepCountBadge } from '../pipeline-step-count-badge';
import { PipelineStepDialog } from '../pipeline-step-dialog';
import { useStepAction } from '../use-step-action';
import { formatRanAt } from './format-ran-at';
import { StepLogPanel } from './step-log-panel';

interface IGrammarStepProps {
  item: ICollectionPipelineStatusV3;
}

export function GrammarStep({ item }: IGrammarStepProps): JSX.Element {
  const { grammar } = item.steps;
  const start = useCallback(
    (force: boolean) =>
      mineGrammarCollectionV1Api({
        collectionId: item.collectionId,
        force,
      }),
    [item.collectionId],
  );
  const action = useStepAction({
    start,
    autoResume: true,
    initialForce: grammar.ranAt !== null,
  });
  return (
    <PipelineStepCell
      badge={<PipelineStepCountBadge step={grammar} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Mine grammar patterns"
          description={`Scan stripped subtitle lines for approved machine patterns, create capped candidates, and prepare grammar clips. ${formatRanAt(grammar.ranAt)} · ${grammar.count} candidates.`}
          dataHref="/sys/grammar"
          dataLabel="Open grammar triage"
          primaryAction={{
            label: grammar.ranAt === null ? 'Run grammar miner' : 'Re-run (force)',
            onClick: action.run,
            pending: action.status === 'running',
            disabledReason: item.subtitleId === null ? 'SRT not imported yet' : undefined,
          }}
          body={<StepLogPanel status={action.status} log={action.log} />}
        />
      )}
    />
  );
}
